import { Injectable } from '@angular/core';
import { LoadingController, Platform } from '@ionic/angular';

import 'cordova-plugin-purchase';
const { store, ProductType, AppleAppStore } = CdvPurchase;
const PRODUCT_MENSUAL_KEY = 'MENSUEL';
const PRODUCT_ANNUAL_KEY = 'ANNUEL';
const PRODUCT_MENSUAL_KEY_APPSTORE = 'MENSUEL';
const PRODUCT_ANNUAL_KEY_APPSTORE = 'ANNUEL';
const PRODUCT_MENSUAL_KEY_PLAYSTORE = 'mensuel';
const PRODUCT_ANNUAL_KEY_PLAYSTORE = 'annuel';
/**
 * ToolsService
 *
 * Ce service permet d'utiliser des outils pratiques
 */
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  myTransactionAnnual = null;
  myTransactionMensual = null;
  annualPrice = null;
  mensualPrice = null;
  annualPriceInt = null;
  mensualPriceInt = null;
  loading = null;
  /**
   * Constructeur
   *
   * Crée une instance de PaymentService.
   */
  constructor(
    private platform: Platform,
    private loadingCtrl: LoadingController
  ) {
    this.platform.ready().then(() => {
      const store: CdvPurchase.Store = new window.CdvPurchase.Store();
      console.log('store', store);
      this.registerProducts();
    });
  }

  getPayInfos() {
    console.log('getPayInfos', this.myTransactionAnnual, this.myTransactionMensual, this.annualPriceInt, this.annualPrice, this.mensualPrice, this.mensualPriceInt);
    return {
      annual: this.myTransactionAnnual,
      mensual: this.myTransactionMensual,
      annualPriceInt: this.annualPriceInt,
      annualPrice: this.annualPrice,
      mensualPrice: this.mensualPrice,
      mensualPriceInt: this.mensualPriceInt
    }
  }

  async requestPaymentAnnual() {
    console.log('requestPaymentAnnual');
    try {
      await this.presentLoading();
      const product = CdvPurchase.store.get(this.platform.is('ios') ? PRODUCT_ANNUAL_KEY_APPSTORE :   PRODUCT_ANNUAL_KEY_PLAYSTORE);
      console.log('product', product);
      const offer = this.platform.is('ios') ? product.getOffer() : product.getOffer("annuel@annuel@trial-annuel");
      console.log('offer', offer);
      offer.order();

      console.log('requestPaymentAnnual offer', offer);
      return true;
    }
    catch (error) {
      console.log('error', error);
      return false;
    }
    finally {
      return false;
    }
  }

  async restorePurchases() {
    CdvPurchase.store.restorePurchases();
  }

  async requestPaymentMensual() {
    console.log('requestPaymentMensual');
    try {
      await this.presentLoading();

      const product = CdvPurchase.store.get(this.platform.is('ios') ? PRODUCT_MENSUAL_KEY_APPSTORE : PRODUCT_MENSUAL_KEY_PLAYSTORE);
      console.log('product', product);
      const offer = this.platform.is('ios') ? product.getOffer() : product.getOffer("mensuel@mensuel@trial-mensuel");
      console.log('offer', offer);
      offer.order();

      this.hideLoading();
      return true;
    }
    catch (error) {
      console.log('error', error);
      this.hideLoading();
      return false;
    }
    finally {
      this.hideLoading();
      return false;
    }
  }

  registerProducts() {
    store.verbosity = 4; //to debug
    store.register([
      {
        id: PRODUCT_ANNUAL_KEY_APPSTORE,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: PRODUCT_MENSUAL_KEY_APPSTORE,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: PRODUCT_ANNUAL_KEY_PLAYSTORE,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,

        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: PRODUCT_MENSUAL_KEY_PLAYSTORE,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,

        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },

      {
        id: PRODUCT_ANNUAL_KEY,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
        platform: CdvPurchase.Platform.TEST
      },

      {
        id: PRODUCT_MENSUAL_KEY,
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
        platform: CdvPurchase.Platform.TEST
      }



    ]);

    if (this.platform.is('ios')) {
      console.log('init apple');
      store.initialize([{ platform: CdvPurchase.Platform.APPLE_APPSTORE }]);
    } else if (this.platform.is('android')) {
      console.log('init google');
      store.initialize([{ platform: CdvPurchase.Platform.GOOGLE_PLAY }]);
    } else {
      console.log('not mobile');
      store.initialize([{ platform: CdvPurchase.Platform.TEST }])
    }

    store.when()
      .verified(receipt => {
        console.log('Areceipt Verified', receipt)
        console.log('A receipt native transaction log', receipt.nativeTransactions)
        receipt.finish()
      })
      .unverified(receipt => {
        console.log('A unverified payload', receipt.payload)
        console.log('A unverified receipt', receipt.receipt)
      })
      .receiptUpdated((receipt) => {
        console.log('A Receipt Update', receipt)
        if(receipt.transactions.length > 0){
          this.updatePurchases(receipt);
        }
      });

    store.when()
      .productUpdated(productBrut => {
        console.log('B Update product', productBrut)
        let product: any = productBrut;
        if(product.platform === CdvPurchase.Platform.APPLE_APPSTORE){
          if (product.id === PRODUCT_ANNUAL_KEY_APPSTORE) {
            this.annualPrice = product.raw.price;
            this.myTransactionAnnual = product.owned;
            this.annualPriceInt = product.raw.priceMicros / 1000000;
          }
          if (product.id === PRODUCT_MENSUAL_KEY_APPSTORE) {
            this.mensualPrice = product.raw.price;
            this.myTransactionMensual = product.owned;
          }
        }
        else if(product.platform === CdvPurchase.Platform.GOOGLE_PLAY){
          let offer_classic = product.offers.find(offer => offer.pricingPhases.length === 1);
          console.log('offer_classic', offer_classic);
          if (product.id === PRODUCT_ANNUAL_KEY_PLAYSTORE) {
            this.annualPrice = offer_classic.pricingPhases[0].price;
            this.myTransactionAnnual = product.owned;
            this.annualPriceInt = offer_classic.pricingPhases[0].priceMicros / 1000000;
          }
          if (product.id === PRODUCT_MENSUAL_KEY_PLAYSTORE) {
            this.mensualPrice = offer_classic.pricingPhases[0].price;
            this.myTransactionMensual = product.owned;

          }

        }
      })
      .approved(transaction => {
        console.log('B transaction happening');
        const monitor = store.monitor(transaction, state => {
          console.log('B new State: ' + state);
          if (state === 'finished') {
            console.log('B transaction state', transaction.state)
            monitor.stop();
          }
        }, 'callbackStore')
        console.log('B transaction verify trigger', transaction.verify)
        transaction.verify()
      })
      .verified(receipt => {
        console.log('B receipt Verified', receipt)
        console.log('B receipt native transaction log', receipt.nativeTransactions)
        receipt.finish()
      })
      .unverified(receipt => {
        console.log('B unverified payload', receipt.payload)
        console.log('B unverified receipt', receipt.receipt)
      })
      .receiptUpdated((receipt) => {
        console.log('B Receipt Update', receipt)
        if(receipt.transactions.length > 0){
          this.updatePurchases(receipt);
        }
      });
  }
  updatePurchases(receipt: CdvPurchase.Receipt) {
    receipt.transactions.forEach(transaction => {
      console.log(`updatePurchases:`,transaction.state, transaction);
      if(transaction.state === 'finished'){
        transaction.products.forEach(trProduct => {
          if (trProduct.id === PRODUCT_ANNUAL_KEY_APPSTORE || trProduct.id === PRODUCT_ANNUAL_KEY || trProduct.id === PRODUCT_ANNUAL_KEY_PLAYSTORE) {
            console.log(`product owned: ${trProduct.id}`);
            this.myTransactionAnnual = true;
          }
          if (trProduct.id === PRODUCT_MENSUAL_KEY_APPSTORE || trProduct.id === PRODUCT_MENSUAL_KEY || trProduct.id === PRODUCT_MENSUAL_KEY_PLAYSTORE) {
            console.log(`product owned: ${trProduct.id}`);
            this.myTransactionMensual = true;
          }
        });
      }
    });
  }
  callbackStore = (data) => {
    console.log('callbackStore', data);
  }



  async presentLoading(content = "Veuillez patienter...") {
    this.loading = await this.loadingCtrl.create({
      message: content,
      duration: 3000
    });

    this.loading.present();

    setTimeout(() => {
      this.hideLoading();
    },4000);
  }

  hideLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }
}
